import React from 'react';
import PropTypes from 'prop-types';
import {TooltipButton} from './TooltipButton';
/**
 * ControlButtons:
 *  - Renders the list of buttons to be displayed on Tooltip
 */
export function ControlButtons(props) {
  return props.buttonList.map((controlItem, key) => (
    <TooltipButton key={key} {...controlItem} />
  ));
}

ControlButtons.propTypes = {
  /**
   * List of buttons to display on Tooltip
   */
  buttonList: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Label for button
       */
      label: PropTypes.string,
      /**
       * Icon url for button
       */
      image: PropTypes.string,
      /**
       * Callback funtion to execute when button clicked
       */
      onClick: PropTypes.func,
    })
  ),
};

ControlButtons.defaultProps = {};
